import React, { useMemo } from "react";
import { useIntl, defineMessages } from "react-intl";
import Tabs from "theme/components/organisms/Tabs";
import Wysiwyg from "theme/modules/WysiwygV2";
import FeatureList, { Feature } from "theme/components/organisms/FeatureList";
import Icon from "theme/components/atoms/Icon";
import ProductReviews, {
  hasProductReviews,
} from "theme/modules/Reviews/ProductReviews";

const messages = defineMessages({
  description: {
    id: "modules.ProductView.ProductDescription.description",
    defaultMessage: "Description",
  },
  details: {
    id: "modules.ProductView.ProductDescription.details",
    defaultMessage: "Details and product description",
  },
  reviews: {
    id: "modules.ProductView.ProductDescription.reviews",
    defaultMessage: "Reviews {count, plural, =0 {} other {(#)}}",
  },
});

export const hasDescription = (product) => {
  return product.descriptionWysiwyg || hasProductReviews(product);
};

const ProductDescription = ({ product }) => {
  const intl = useIntl();

  const tabs = useMemo(
    () => [
      product.descriptionWysiwyg
        ? {
            key: "description",
            anchor: "description",
            label: intl.formatMessage(messages.description),
            children: (
              <FeatureList appearance="center">
                <Feature
                  appearance="mega"
                  icon={<Icon size="big" icon="list" title="" />}
                  title={intl.formatMessage(messages.details)}
                  description={
                    <div itemProp="description">
                      <Wysiwyg content={product.descriptionWysiwyg} />
                    </div>
                  }
                />
              </FeatureList>
            ),
          }
        : null,
      hasProductReviews(product)
        ? {
            key: "reviews",
            anchor: "reviews",
            label: intl.formatMessage(messages.reviews, {
              count: product.reviewsLayer.total,
            }),
            children: <ProductReviews product={product} />,
          }
        : null,
    ],
    [intl, product]
  );

  return <Tabs tabs={tabs} />;
};

export default ProductDescription;
